module.exports = __webpack_public_path__ + "static/location-info2-26a22e08ba52ac34daadb60250134388.jpg";